import React from 'react';

const WhatYoullLearn = () => {
  const modules = [
    {
      number: 1,
      title: "Framing the Future",
      description: "Why \"intelligent HR\" is the next shift after digital transformation",
      outcome: "Strategic context"
    },
    {
      number: 2,
      title: "How AI Actually Works",
      description: "The simple, practical view of how LLMs generate and refine content",
      outcome: "Confidence in usage"
    },
    {
      number: 3,
      title: "Prompting for Results",
      description: "Learn a 5-step prompt structure with examples you can reuse",
      outcome: "Better, faster outputs"
    },
    {
      number: 4,
      title: "AI in Action",
      description: "Watch 3 real HR examples come to life using ChatGPT, Claude, Gemini, and Perplexity",
      outcome: "Immediate, transferable value"
    },
    {
      number: 5,
      title: "Productivity Edge",
      description: "Map out the 5 areas where AI can transform HR efficiency",
      outcome: "Clear next steps"
    }
  ];

  return (
    <section className="what-youll-learn">
      <div className="container">
        <h2 className="section-title">What You'll Learn</h2>
        <div className="modules-grid">
          {modules.map((module) => (
            <div key={module.number} className="module">
              <div className="module-number">{module.number}</div>
              <h3>{module.title}</h3>
              <p className="module-desc">{module.description}</p>
              <span className="module-outcome">{module.outcome}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatYoullLearn;
